import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector1EBlue = ({ state, workState }) => (
	<g id="Track-1E-blue-connector" transform="translate(800.000000, 728.000000)">
		<path
			d="M289.954837,323.340913 L310.36258,311.312265 C317.718036,306.976842 327.014593,307.788882 333.507008,313.333895 L341.318,320.005074 L341.318,320.005074"
			strokeLinecap="round"
			strokeWidth={tracksWidth}
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}/>
	</g>
);

export default Connector1EBlue;